import React from 'react'
import img3 from '../../assets/img/img3.png'
import svg7 from '../../assets/img/svg7.png'
import svg10 from '../../assets/img/svg10.png'

function Experience() {
  return (
    <section className="bg-white overflow-hidden">
        <div className="grid max-w-screen-lg px-4 py-8 mx-auto lg:py-16 lg:grid-cols-12 ">
            <div className="mr-auto place-self-center lg:col-span-7 px-10 md:p-0">
                <div class="max-w-2xl mx-auto text-center">
                    <h2 class="text-gray-800 font-bold text-xl mb-2 md:mb-4">Professional journey</h2>
                    <p class="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600">
                        Introducing my professional journey: Explore a brief overview here, and for a more comprehensive history, 
                        please visit my <a href="https://www.linkedin.com/in/danny-baraka/" target="_blank" className="text-blue-700 underline hover:text-blue-500">LinkedIn profile.</a> 
                    </p>
                </div>
                <ul className="space-y-8 mt-10">
                    <li class="relative flex items-start">
                        <div class="-ml-0.5 absolute mt-0.5 top-9 left-4 w-px border-l-4 border-dotted border-gray-300 h-full" aria-hidden="true"></div>

                        <div class="relative flex items-center justify-center flex-shrink-0 w-8 h-8 bg-white rounded-full shadow">
                            <svg class="w-5 h-5 text-primaryGreen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <div class="ml-6">
                            <h3 class="text-lg font-semibold text-gray-800">Full stack Software developer (Jul 2023 - Present)</h3>
                            <p class="mt-2 text-base text-gray-600">Termas Designs, Toronto Canada</p>
                        </div>
                    </li>
                    <li class="relative flex items-start">
                        <div class="-ml-0.5 absolute mt-0.5 top-9 left-4 w-px border-l-4 border-dotted border-gray-300 h-full" aria-hidden="true"></div>

                        <div class="relative flex items-center justify-center flex-shrink-0 w-8 h-8 bg-white rounded-full shadow">
                            <svg class="w-5 h-5 text-primaryGreen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <div class="ml-6">
                            <h3 class="text-lg font-semibold text-gray-800">Software Engineer Mentor (Jun 2023 - Present)</h3>
                            <p class="mt-2 text-base text-gray-600">Springboard, San Francisco United States</p>
                        </div>
                    </li>
                    <li class="relative flex items-start">
                        <div class="-ml-0.5 absolute mt-0.5 top-9 left-4 w-px border-l-4 border-dotted border-gray-300 h-full" aria-hidden="true"></div>

                        <div class="relative flex items-center justify-center flex-shrink-0 w-8 h-8 bg-white rounded-full shadow">
                            <svg class="w-5 h-5 text-primaryGreen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <div class="ml-6">
                            <h3 class="text-lg font-semibold text-gray-800">Frontend Developer (Jan 2022 - Present)</h3>
                            <p class="mt-2 text-base text-gray-600">Edunique Transformation, Nairobi Kenya</p>
                        </div>
                    </li>
                    <li class="relative flex items-start">
                        <div class="-ml-0.5 absolute mt-0.5 top-9 left-4 w-px border-l-4 border-dotted border-gray-300 h-full" aria-hidden="true"></div>

                        <div class="relative flex items-center justify-center flex-shrink-0 w-8 h-8 bg-white rounded-full shadow">
                            <svg class="w-5 h-5 text-primaryGreen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <div class="ml-6">
                            <h3 class="text-lg font-semibold text-gray-800">Full-stack Software Developer (Jan 2021 - Dec 2021)</h3>
                            <p class="mt-2 text-base text-gray-600">We The Best, Belarus</p>
                        </div>
                    </li>
                    <li class="relative flex items-start">
                        <div class="relative flex items-center justify-center flex-shrink-0 w-8 h-8 bg-white rounded-full shadow">
                            <svg class="w-5 h-5 text-primaryGreen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <div class="ml-6">
                            <h3 class="text-lg font-semibold text-gray-800">Back End Developer (Mar 2020 - Sep 2020)</h3>
                            <p class="mt-2 text-base text-gray-600">new world technology, DRC Congo</p>
                        </div>
                    </li>

                    
                </ul>
            </div>

            <div className="relative hidden lg:mt-0 lg:col-span-5 lg:inline-flex">
                                
                <div className="relative w-9/12 h-full pb-10 ml-24 z-10">
                    <div className="relative bg-red-400 border border-neutral-300">
                        <div className="h-20 w-full bg-slate-600">
                            <img src={img3} alt="" className= "object-cover h-full w-full" />
                        </div>
                        <div className="bg-white p-10 pr-2">
                            <p className="text-2xl leading-10">Help <br /> companies, <br /> Personal and <br /> communities <br /> to build their <br /> digital <br /> product</p>
                        </div>
                    </div>

                        {/* <%# jump %> */}
                        <div className=" absolute h-28 w-32 bottom-56 -right-24 animate-bounce">
                            <img src={svg10} alt="" className= "object-cover h-full w-full" />
                        </div>
                        
                        {/* <%# conference %> */}
                        <div className=" absolute h-28 w-44 bottom-32 -right-5">
                            <img src={svg7} alt="" className= "object-cover h-full w-full" />
                        </div>
                        
                        <div className="absolute bg-primaryGreen p-6 rounded-full bottom-20 -right-10 ">
                            <p className="text-white text-xl">B.D</p>
                        </div>
                </div>
                {/* here 2 */}
                <div className="absolute w-8/12 h-full ml-32">
                    <div className="relative border border-neutral-300">
                        <div className="h-20 w-full">
                        </div>
                        <div className="bg-neutral-100 pt-2 pb-4">
                            <p className="text-2xl leading-10">Danny <br /> company, <br /> Personal and <br /> community <br /> to build their <br /> digital <br /> product</p>
                            <p className="text-2xl leading-10">Danny <br /> company</p>
                        </div>
                    </div>
                </div>

            </div> 
                           
        </div>
    </section>
  )
}

export default Experience;
